import { FirebaseStorage, ref, getDownloadURL } from 'firebase/storage';
import { Auth } from 'firebase/auth';
import { Firestore, doc } from 'firebase/firestore';
import { fetchWithCache } from '@/firebase/firestore/cache';
import type { ProcessedImage } from '@/lib/types';
import type { AssetStore } from '../contracts/assets';
import { uploadImage, deleteStorageFile, deleteProcessedImage } from '@/firebase/storage';

export class FirebaseAssetStore implements AssetStore {
  constructor(
    private storage: FirebaseStorage,
    private auth: Auth,
    private firestore: Firestore
  ) {}

  async uploadImage(
    file: File | Blob,
    novelId: string,
    subfolder: string
  ): Promise<{ url: string; path: string }> {
    return uploadImage(this.storage, this.auth, file, novelId, subfolder);
  }

  async deleteStorageFile(path: string): Promise<void> {
    return deleteStorageFile(this.storage, path);
  }

  async deleteProcessedImage(image: ProcessedImage): Promise<void> {
    return deleteProcessedImage(this.storage, image);
  }

  async resolveSecureAssetUrl(pathOrUrl: string): Promise<string> {
    if (!pathOrUrl) return '';
    let path = pathOrUrl;

    if (pathOrUrl.startsWith('http')) {
      try {
        const urlObj = new URL(pathOrUrl);
        if (urlObj.hostname === 'storage.googleapis.com' && !urlObj.searchParams.has('token')) {
          const pathSegments = urlObj.pathname.split('/').filter(Boolean);
          path = decodeURIComponent(pathSegments.slice(1).join('/'));
        } else if (urlObj.hostname.includes('firebasestorage.googleapis.com') && urlObj.pathname.includes('/o/')) {
          const oIndex = urlObj.pathname.indexOf('/o/');
          if (oIndex !== -1) {
            path = decodeURIComponent(urlObj.pathname.substring(oIndex + 3));
          }
        } else {
          return pathOrUrl;
        }
      } catch (e) {
        // Invalid URL, treat as path
      }
    } else if (pathOrUrl.startsWith('/') || pathOrUrl.startsWith('data:') || pathOrUrl.startsWith('blob:')) {
      return pathOrUrl;
    }

    if (!path) return '';
    return getDownloadURL(ref(this.storage, path));
  }

  async getDefaultStyleImages(): Promise<Record<string, string>> {
    const defaultStylesRef = doc(this.firestore, 'images', 'default');
    const snapshot = await fetchWithCache(defaultStylesRef);

    if (snapshot.exists()) {
      const data = snapshot.data();
      return {
        style1: data.style1 || '',
        style2: data.style2 || '',
        style3: data.style3 || '',
        style4: data.style4 || '',
      };
    }
    return {};
  }
}

